export const listAcsVersions = /* GraphQL */ `
  query ListAcsVersions(
    $id: ID
    $filter: ModelAcsVersionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAcsVersions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        no
        version
        releaseDate
        active
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;